let inject = [
  '$scope',
  'MainMenuService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'SessionService',
  'NgTableParams',
  '$uibModal'
];

class MainMenuController{
  constructor ($scope,
               MainMenuService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               SessionService,
               NgTableParams,
               $uibModal) {
    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.NgTableParams = NgTableParams;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
    this.MainMenuService = MainMenuService;

  }
  
  $onInit(){
   this.items = [
      'The first choice!',
      'And another choice for you.',
      'but wait! A third!'
    ];
  
  }
  

}

MainMenuController.$inject = inject;

export default MainMenuController;




/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/main-menu/main-menu.controller.js
 **/